import getPageData from "./getPageData";
import nameCityToCode from "./nameCityToCode";

export default async function() {
  try {
    const { cityInfo } = await getPageData();

    return cityInfo.map(v => {
      return { cityCode: nameCityToCode(v.nomeCidade), cityName: v.nomeCidade };
    });
  } catch (e) {
    throw e;
  }
}
